var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "step",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "step-row" },
        [
          _c("file-field", {
            staticClass: "step__file-field",
            attrs: {
              fileType: "image",
              accept: "image/*",
              fieldType: "tokenCreation",
              label: _vm.i18n.sale_token_logo_title(),
              id: "tokenImg",
              type: _vm.documentTypes.tokenIcon,
              disableField: _vm.disableForm
            },
            model: {
              value: _vm.documents[_vm.documentTypes.tokenIcon],
              callback: function($$v) {
                _vm.$set(_vm.documents, _vm.documentTypes.tokenIcon, $$v)
              },
              expression: "documents[documentTypes.tokenIcon]"
            }
          }),
          _vm._v(" "),
          _c("input-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: {
                  required: true,
                  max: 30
                },
                expression:
                  "{\n                  required: true,\n                  max: 30\n                 }"
              }
            ],
            staticClass: "field_medium",
            attrs: {
              id: "token-name",
              name: "token name",
              label: _vm.i18n.sale_name_token_title(),
              placeholder: _vm.i18n.sale_my_token(),
              errorMessage: _vm.errorMessage("token name"),
              disabled: _vm.disableForm
            },
            model: {
              value: _vm.form.tokenName,
              callback: function($$v) {
                _vm.$set(_vm.form, "tokenName", $$v)
              },
              expression: "form.tokenName"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field-mask field_medium" },
            [
              _c("label", { attrs: { for: "token-code" } }, [
                _vm._v(_vm._s(_vm.i18n.sale_token_code_title()))
              ]),
              _vm._v(" "),
              _c("the-mask", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  id: "token-code",
                  name: "token code",
                  placeholder: "ABC01",
                  errorMessage: _vm.errorMessage("token code"),
                  mask: ["XXXXX"],
                  disabled: _vm.disableForm
                },
                model: {
                  value: _vm.form.tokenCode,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "tokenCode", $$v)
                  },
                  expression: "form.tokenCode"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "step-row__description text_small" }, [
            _c("div", [_vm._v(_vm._s(_vm.i18n.sale_token_code_description()))]),
            _vm._v(" "),
            _c("div", [
              _vm._v(_vm._s(_vm.i18n.sale_token_code_description_2()))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "step-row__title text_small" },
            [
              _c(
                "md-checkbox",
                {
                  staticClass: "md-primary",
                  attrs: {
                    value: _vm.ASSET_POLICIES.transferable,
                    name: "policy-transferable",
                    id: "policy-transferable",
                    disabled: _vm.disableForm
                  },
                  model: {
                    value: _vm.form.policies,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "policies", $$v)
                    },
                    expression: "form.policies"
                  }
                },
                [
                  _c("div", { staticClass: "step__token-checkbox" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_is_transferable()))
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field-icon__wrap" },
            [
              _c("input-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|amount",
                    expression: "'required|amount'"
                  }
                ],
                staticClass: "field_medium field__number",
                attrs: {
                  id: "token-max-issuance-amount",
                  name: "max issuance amount",
                  type: "number",
                  label: _vm.i18n.sale_token_for_sale(),
                  placeholder: _vm.i18n.lbl_token_max_issuance_amount(),
                  errorMessage: _vm.errorMessage("max issuance amount"),
                  disabled: _vm.disableForm
                },
                model: {
                  value: _vm.form.maxIssuanceAmount,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "maxIssuanceAmount", $$v)
                  },
                  expression: "form.maxIssuanceAmount"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "field-icon" }, [
                _vm._v(_vm._s(_vm.form.tokenCode))
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.disableForm
        ? _c("div", { staticClass: "step__token-created" }, [
            _vm._v(_vm._s(_vm.i18n.sale_token_created()))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap column" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: { type: "submit", disabled: _vm.isPending }
            },
            [_vm._v("\n      " + _vm._s(_vm.i18n.sale_next_step()) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "simple-link arrow_back",
              on: {
                click: function($event) {
                  return _vm.stepBack()
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_go_back_2()) + "\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-114287b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-114287b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/saleCreation/steps/Step.TokenCreation.vue
// module id = 1soR
// module chunks = 1